import  { useRef } from 'react'
import Breadcrumbs from '../../../common-elements/breadcrumbs/Breadcrumbs'
import { useTranslation } from 'react-i18next'
import {Card, CardBody, Container, Table } from 'reactstrap'
import { useParams } from 'react-router-dom'
import { InvoiceData } from './InvoiceList'
import { useReactToPrint } from "react-to-print";
import InvoiceFiveHeader from './invoice-data/InvoiceFiveHeader'
import InvoiceNumber from './invoice-data/InvoiceNumber'
import InvoiceTable from './invoice-data/InvoiceTable'
import InvoiceFiveSign from './invoice-data/InvoiceFiveSign'
import InvoiceButtons from '../../../common-elements/button/InvoiceButtons'
 
function ViewInvoiceSection() {
    const {t}=useTranslation()
    const { id } = useParams();
    const contentRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = useReactToPrint({ contentRef });
    const Data = InvoiceData.find(
        (user: any) => user.id.toString() === id
      );
      
  return (
    <>
    <Breadcrumbs
        mainTitle={t("ViewInvoice")}
        parent={t("BillsPayment")}
        parentLink={`${process.env.PUBLIC_URL}/billingpayments/invoice`}
      />
       <Container className="invoice-5">
        <Card>
          <CardBody>
        <div ref={contentRef}>
          <Table borderless>
            <tbody>
              <tr>
                <td>
                  <InvoiceFiveHeader data={Data}/>
                </td>
              </tr>
              <tr>
                <InvoiceNumber data={Data}/>
              </tr>
              <tr>
                <InvoiceTable data={Data}/>
              </tr>
              <InvoiceFiveSign />
            </tbody>
          </Table>
        </div>
        <InvoiceButtons handlePrint={handlePrint} />
        </CardBody>
        </Card>
      </Container>
    </>
  )
}

export default ViewInvoiceSection
